"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Row = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Row = function (props) {
    var _a;
    return (jsx_runtime_1.jsx("div", __assign({ className: "row " + ((_a = props.className) !== null && _a !== void 0 ? _a : '') }, props, { children: props.children }), void 0));
};
exports.Row = Row;
//# sourceMappingURL=Row.js.map